export default "__VITE_ASSET__7ebd98db__"